import { render, staticRenderFns } from "./InfoPromotions.vue?vue&type=template&id=6ac210e7&scoped=true"
import script from "./InfoPromotions.vue?vue&type=script&lang=js"
export * from "./InfoPromotions.vue?vue&type=script&lang=js"
import style0 from "./InfoPromotions.vue?vue&type=style&index=0&id=6ac210e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac210e7",
  null
  
)

export default component.exports